import type { IPoint3d } from '@/editor/math/IPoint3d';

/** 菜单矩形相对锚点所在的象限 */
export enum EMenuQuadrant {
  /** 菜单左下角贴锚点 */
  rightTop = 'rightTop',
  /** 菜单左上角贴锚点 */
  rightBottom = 'rightBottom',
  /** 菜单右下角贴锚点 */
  leftTop = 'leftTop',
  /** 菜单右上角贴锚点 */
  leftBottom = 'leftBottom'
}

export interface IAnchorCorner {
  /** 世界坐标（mm），2D 下 z 恒为 0 */
  point: IPoint3d;
  /** 落在实体内部、不允许摆菜单的象限。只有 2D 的房间与分区会产出 */
  blockedQuadrants: EMenuQuadrant[];
}

export type TContextMenuAnchor =
  | { kind: 'corners'; corners: IAnchorCorner[] }
  /** 菜单被拖过，固定停在用户放的那个点上，不再翻方位 */
  | { kind: 'manual'; point: IPoint3d }
  /** 开关关闭时的单点锚。移除 CTX_MENU_POS_OPTIMIZE 时连同 anchorResolver.ts 一起删 */
  | { kind: 'legacy'; point: IPoint3d };
